import { render, staticRenderFns } from "./ReservationFiles.vue?vue&type=template&id=49c4beb9&scoped=true&"
import script from "./ReservationFiles.vue?vue&type=script&lang=js&"
export * from "./ReservationFiles.vue?vue&type=script&lang=js&"
import style0 from "./ReservationFiles.vue?vue&type=style&index=0&id=49c4beb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c4beb9",
  null
  
)

export default component.exports